var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconEditHover(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 19.382,
    height: 19.085,
    viewBox: "0 0 19.382 19.085",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_238",
    "data-name": "Rectangle 238",
    width: 19.382,
    height: 19.085,
    fill: "#fff"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_567",
    "data-name": "Group 567",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_262",
    "data-name": "Path 262",
    d: "M23.823,14.287c.052-.579.1-1.159.157-1.738.029-.314.065-.627.092-.941a1.651,1.651,0,0,1,.534-1.044Q28.49,6.686,32.369,2.8,33.39,1.783,34.411.762A2.552,2.552,0,0,1,38.029.74c.251.245.5.494.733.756a2.455,2.455,0,0,1-.056,3.3c-.357.377-.731.739-1.1,1.106-2.895,2.9-5.8,5.783-8.678,8.693a2.412,2.412,0,0,1-1.676.745c-.72.04-1.438.129-2.157.19a1.164,1.164,0,0,1-1.273-1.244m1.568-.207c.656-.062,1.312-.126,1.968-.184a.659.659,0,0,0,.45-.184q3.943-3.954,7.9-7.9c.143-.142.127-.219-.008-.35-.607-.594-1.2-1.2-1.806-1.8-.2-.2-.2-.2-.4,0l-5.5,5.521q-1.175,1.179-2.353,2.355a.446.446,0,0,0-.172.278c-.064.705-.134,1.409-.2,2.114-.01.1.016.168.135.15M37.957,3.112a1,1,0,0,0-.31-.762q-.322-.333-.655-.655a1.06,1.06,0,0,0-1.5-.015c-.236.22-.455.458-.689.681-.092.088-.093.147,0,.238q.973.962,1.936,1.935c.092.093.154.116.254.009.211-.225.437-.436.651-.658a1,1,0,0,0,.311-.772",
    transform: "translate(-21.784 0)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_263",
    "data-name": "Path 263",
    d: "M9.714,206.707q4.436,0,8.872,0a.731.731,0,0,1,.735.425.694.694,0,0,1-.455.951,1.422,1.422,0,0,1-.376.038H.893a.988.988,0,0,1-.566-.126.682.682,0,0,1-.305-.746.714.714,0,0,1,.651-.539c.077,0,.155,0,.232,0H9.714",
    transform: "translate(0 -189.035)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconEditHover);
export default __webpack_public_path__ + "static/media/icon_edit_hover.4c8b8c121b081195de516d876dd036e0.svg";
export { ForwardRef as ReactComponent };